// Mapper: transport LC_MonitoringCountersOut → domain MonitoringCounters.
// Both shapes hold the same four numbers; the mapper keeps the UI decoupled from
// the wire DTO and normalizes missing values to 0.

import type {
  LC_MonitoringCountersOut,
  MonitoringCounters,
} from '../types/monitoringCounters.types';


export function mapMonitoringCounters(
  out: LC_MonitoringCountersOut,
): MonitoringCounters {
  return {
    totalActive: out.totalActive ?? 0,
    absent: out.absent ?? 0,
    justified: out.justified ?? 0,
    present: out.present ?? 0,
  };
}
